import {
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
  TIContainerInformationExtendedValid,
} from "@tedivo/tedivo-bay-grid-pure";
import { BayLevelEnum } from "open-vessel-definition";

import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";

export function getContainersByHighestBelowOrLowestAbove(
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
): TGetContainersFilterOutput {
  const containers: TIContainerInformationExtendedValid[] = [];

  const { gridContent, allStacksKeys, allTiersKeys } = smartBay.getGridContent();

  // For each stack, get the highest container below deck or lowest above deck
  for (const stackKey of allStacksKeys) {
    const tiersInStack = allTiersKeys.filter((tier) => gridContent[stackKey]?.[tier]);

    if (tiersInStack.length === 0) continue;

    // Sort tiers from bottom to top
    const sortedTiers = tiersInStack.sort();

    // Check if this is below or above deck
    if (smartBay.level === BayLevelEnum.BELOW) {
      // Get highest below (last tier)
      const highestTier = sortedTiers[sortedTiers.length - 1];
      const content = gridContent[stackKey]?.[highestTier];
      if (content) {
        containers.push(...(content.containers as TIContainerInformationExtendedValid[]));
      }
    } else {
      // Get lowest above (first tier)
      const lowestTier = sortedTiers[0];
      const content = gridContent[stackKey]?.[lowestTier];
      if (content) {
        containers.push(...(content.containers as TIContainerInformationExtendedValid[]));
      }
    }
  }

  return {
    containers,
    tBaysStr: smartBay.tBaysStr,
    level: smartBay.level,
  };
}
